import script from "./tjpa-demandas-drawer.vue?vue&type=script&setup=true&lang=js"
export * from "./tjpa-demandas-drawer.vue?vue&type=script&setup=true&lang=js"

import "./tjpa-demandas-drawer.vue?vue&type=style&index=0&id=508bfc8a&lang=scss&scoped=true"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-508bfc8a"]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QImg,QScrollArea,QList,QItem,QItemSection,QBtn});
